import React, { useEffect, useState } from 'react';
import style from './../adminSect.module.scss';
import { CustomButton } from '../../utils/Utils';
import ManageTabs from './ManageTabs';
import { SmallModal } from '../../utils/Modals';
import apiConnect from '../../../config/apiConfig';
import { message } from 'antd';

const ManageFeria = () => {
  const { sectHeader, manageFeriaHeader, headerTitle, fullVH } = style;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAccessOpen, setIsAccesOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleModal = (set, state) => {
    set(!state);
  };

  const modifyUsersAccess = async () => {
    try {
      setIsLoading(true);
      await apiConnect.patch('/users/manage-access', {
        isAccessOpen: !isAccessOpen,
      });
      setIsAccesOpen(!isAccessOpen);
      setIsModalOpen(false);
    } catch (error) {
      message.error('Ha ocurrido un error al restringir acceso a usuarios.');
    } finally {
      setIsLoading(false);
    }
  };

  const getAccessStatus = async () => {
    try {
      setIsLoading(true);
      const { data } = await apiConnect.get('/users/access-status');
      setIsAccesOpen(data.isAccessOpen);
    } catch (error) {
      message.error('Ha ocurrido un error al recuperar el estado de acceso de los usuarios.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  return (
    <div className={fullVH}>
      <div className={`${sectHeader} ${manageFeriaHeader}`}>
        <div className={headerTitle}>
          <h1>
            <b>Administrar Feria</b>
          </h1>
        </div>
        <div>
          <CustomButton
            color={isAccessOpen ? 'btnPrimary' : 'btnOrange'}
            content={isAccessOpen ? 'RESTRINGIR USUARIOS' : 'HABILITAR USUARIOS'}
            size="bg"
            onclick={() => toggleModal(setIsModalOpen, isModalOpen)}
          />
        </div>
      </div>
      <ManageTabs />
      <SmallModal
        title={isAccessOpen ? '¿Seguro que quiere restringir el acceso a los usuarios?' : '¿Seguro que quiere habilitar el acceso a los usuarios?'}
        toggle={toggleModal}
        state={isModalOpen}
        set={setIsModalOpen}
        howManyBtn="2"
        firstBtn={{
          color: 'btnOrange',
          content: 'Cerrar',
          onclick: () => {
            setIsModalOpen(false);
          },
        }}
        secondBtn={{
          color: 'btnOutline',
          content: 'Confirmar',
          disabled: isLoading,
          onclick: () => {
            modifyUsersAccess();
          },
        }}
      />
    </div>
  );
};

export default ManageFeria;
